import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Layout from "../../components/Layout.js";
import Select from "react-select";
import { apiFetch } from "../../api.js";

const AccessoriesMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const allowAlphabets = (value) => value.replace(/[^a-zA-Z ]/g, "");
  const allowNumbers = (value) => value.replace(/[^0-9]/g, "");
  const [Category, setCategory] = useState("");
  const [Model, setModel] = useState("");
  // const [Modellist, setModellist] = useState([]);
  const [Categorylist, setCategorylist] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [Item, setItem] = useState("");
  const [Partno, setPartno] = useState("");
  const [PartName, setPartName] = useState("");
  const [Unit, setUnit] = useState("");
  const UnitList = [];
  const [YesNo, setYesNo] = useState("D");
  const [ReorderLevel, setReorderLevel] = useState("");
  const [HSNCode, setHSNCode] = useState("");
  const [NDP, setNDP] = useState("");
  const [MRP, setMRP] = useState("");
  const [QtyUsed, setQtyUsed] = useState("");
  const [GSTPercentage, setGSTPercentage] = useState("");
  const [GSTPercentageList, setGSTPercentageList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState({});
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const [ModelDropdownList, setModelDropdownList] = useState([]);
  const [GridModelList, setGridModelList] = useState([]);
  const categoryOptions = Categorylist.map((c) => ({
    value: c.value,
    label: c.label,
  }));
  const modelOptions = ModelDropdownList.map((m) => ({
    value: m.value,
    label: m.label,
  }));
  const gstOptions = GSTPercentageList.map((g) => ({
    value: g.value,
    label: g.label,
  }));
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "45px",
      borderRadius: "6px",
      borderColor: "#ccc",
    }),
  };

  useEffect(() => {
    fetchGSTList();
    fetchCategoryList();
    fetchModelList();
  }, []);

  // DETECT EDIT MODE ON FIRST PAGE LOAD
  useEffect(() => {
    const unq = location.state?.unq;
    if (unq) {
      setIsEditMode(true);
      loadEditData(unq);
    } else {
      fetchGridData();
    }
  }, []);

  // FETCH GRID DATA ONLY IN ADD MODE
  useEffect(() => {
    const unq = location.state?.unq;
    if (!unq) {
      fetchGridData();
    }
  }, [Model]);

  const fetchGSTList = async () => {
    try {
      const response = await apiFetch(
        "/api/gst/list",
      );

      const data = await response.json(); // 🔥 CHANGE HERE
      setGSTPercentageList(data);
    } catch (error) {
      console.error("Error fetching GST:", error);
    }
  };
  const fetchCategoryList = async () => {
    try {
      const response = await apiFetch(
        "/api/category/list",
      );

      const data = await response.json();
      setCategorylist(data);
    } catch (error) {
      console.error("Error fetching Category list:", error);
    }
  };
  const fetchModelList = async () => {
    try {
      const response = await apiFetch(
        "/api/model/list",
      );

      const data = await response.json();
      setModelDropdownList(data);
    } catch (error) {
      console.error("Error fetching model list:", error);
    }
  };
  const fetchGridData = async () => {
    try {
      const payload = { modelUnq: Model, fuel: "", fsc: "" };

      const response = await apiFetch(
        `/api/accessories/refreshdata`,
        {
          method: "POST",
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      setGridModelList(
        (data || []).map((item) => ({
          value: item.unq,
          model: item.model,
          variant: item.variant,
          qtyUsed: item.qty,
        })),
      );
    } catch (error) {
      console.error("Grid fetch error:", error);
    }
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    const updated = {};

    GridModelList.forEach((m) => {
      updated[m.value] = checked;
    });

    setSelectedRows(updated);
    setSelectAll(checked);
  };

  const handleRowSelect = (value) => {
    const updated = { ...selectedRows, [value]: !selectedRows[value] };
    setSelectedRows(updated);
    const allSelected =
      GridModelList.length > 0 && GridModelList.every((m) => updated[m.value]);

    setSelectAll(allSelected);
  };

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((response) => response.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  const handleSave = async () => {
    try {
      const mainPayload = {
        Item,
        Partno,
        PartName,
        Unit,
        YesNo,
        ReorderLevel,
        HSNCode,
        NDP,
        MRP,
        QtyUsed,
        GSTPercentage,
        Category,
        Model,
        userId: storedUserInfo.userId,
        ipAddress: ipAddress,
        serverIp: window.location.hostname,
      };

      const mainRes = await apiFetch(
        `/api/accessories/saveMain`,
        {
          method: "POST",
          body: JSON.stringify(mainPayload),
        },
      );

      // 🔥 FIX HERE
      const mainData = await mainRes.json();
      const mainUnqid = mainData.unqid;

      if (!mainUnqid) {
        alert("Main record did not return UNQID!");
        return;
      }

      const childRows = GridModelList.filter(
        (row) => selectedRows[row.value],
      ).map((row) => ({
        model: row.model,
        variant: row.variant,
        qtyUsed: row.qtyUsed,
        modelunq: row.value,
        checkbox: "Y",
      }));

      if (childRows.length > 0) {
        await apiFetch(`/api/accessories/saveChild`, {
          method: "POST",
          body: JSON.stringify({
            mainUnqid,
            rows: childRows,
          }),
        });
      }

      alert("Accessories saved successfully!");
      navigate("/AccessoriesmasterGrid");
    } catch (error) {
      console.error("SAVE ERROR:", error);
      alert("Error saving data!");
    }
  };

  const handleExit = () => {
    navigate("/AccessoriesmasterGrid");
  };

  useEffect(() => {
    if (location.state?.unq) {
      setIsEditMode(true);
      loadEditData(location.state.unq);
    }
  }, []);

  const loadEditData = async (unq) => {
    try {
      const res = await apiFetch(
        `/api/accessories/edit`,
        {
          method: "POST",
          body: JSON.stringify({ unqid: unq }), // ✅ FI
        },
      );
      const data = await res.json(); // ✅ FIX
      const parent = data.parent;
      const child = data.child;

      // Set parent fields
      setItem(parent.item);
      setPartno(parent.itemcode);
      setPartName(parent.name);
      setUnit(parent.unit);
      setYesNo(parent.serialno);
      setReorderLevel(parent.level);
      setHSNCode(parent.hsncode);
      setNDP(parent.ndp);
      setMRP(parent.mrp);
      setQtyUsed(parent.qty);
      setCategory(parent.categoryid);
      setGSTPercentage(parent.gstid);
      setModel(parent.modelunq);
      // Child grid rows
      const rows = child.map((ch) => ({
        childunq: ch.childunq,
        value: ch.modelunq,
        model: ch.model,
        variant: ch.variant,
        qtyUsed: ch.qty,
      }));
      setGridModelList(rows);

      // Checkbox selections
      const selections = {};
      child.forEach((c) => {
        selections[c.modelunq] = c.val === true;
      });
      setSelectedRows(selections);

      // Select All (CORRECT)
      setSelectAll(child.every((c) => c.val === true));

      console.log(parent);
      console.log(child);
    } catch (error) {
      console.log("❌ EDIT LOAD ERROR", error);
    }
  };

  const handleUpdate = async () => {
    try {
      const mainPayload = {
        Unq: location.state.unq, // record id for update
        Item,
        Partno,
        PartName,
        Unit,
        YesNo,
        ReorderLevel,
        HSNCode,
        NDP,
        MRP,
        QtyUsed,
        GSTPercentage,
        Category,
        Model,
        userId: storedUserInfo.userId,
        ipAddress,
        serverIp: window.location.hostname,
        childRows: GridModelList.map((row) => ({
          childunq: row.childunq || "", // MUST send
          modelunq: row.value,
          variant: row.variant, // MUST send
          qtyUsed: row.qtyUsed,
          checkbox: selectedRows[row.value] ? "Y" : "N",
        })),
      };

      const res = await apiFetch(
        `/api/accessories/update`,
        {
          method: "POST",
          body: JSON.stringify(mainPayload),
        },
      );

      alert("Updated Successfully");

      navigate("/AccessoriesmasterGrid");
    } catch (err) {
      console.error("UPDATE ERROR:", err);
      alert("Error updating!");
    }
  };

  const inputStyle = (error) => ({
    padding: "12px 15px",
    height: "45px",
    marginTop: "5px",
    borderRadius: "6px",
    border: error ? "2px solid red" : "1px solid #ccc",
    width: "100%",
    fontSize: "15px",
    boxSizing: "border-box",
    backgroundColor: "#fff",
  });

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap", // 🔥 no wrapping (forces one row)
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });
  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Accessories Master</div>

          {/* Form Section */}
          <div className="form-row">
            <div className="form-column">
              <label>Item</label>
              <input
                type="text"
                value={Item}
                onChange={(e) => setItem(allowAlphabets(e.target.value))}
                style={inputStyle(errors.Category)}
              />
            </div>
            <div className="form-column">
              <label>Part No</label>
              <input
                type="text"
                value={Partno}
                onChange={(e) => setPartno(e.target.value)}
                style={inputStyle(errors.Category)}
              />
            </div>
            <div className="form-column">
              <label>Part Name</label>
              <input
                type="text"
                value={PartName}
                onChange={(e) => setPartName(allowAlphabets(e.target.value))}
                style={inputStyle(errors.Category)}
              />
            </div>
            <div className="form-column">
              <label>Unit</label>
              <select
                value={Unit}
                onChange={(e) => setUnit(e.target.value)}
                style={inputStyle(errors.Unit)}
              >
                <option value="">Select Unit</option>
                <option value="PCS">PCS</option>
                <option value="KG">KG</option>
                <option value="L">L</option>
                {UnitList.map((x, i) => (
                  <option key={i + "Unit"} value={x.value}>
                    {x.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-column">
              <label>Product Serial No</label>
              <div>
                <label style={{ fontWeight: "bold", marginRight: "15px" }}>
                  <input
                    type="radio"
                    value="D"
                    checked={YesNo === "D"}
                    onChange={(e) => setYesNo(e.target.value)}
                  />
                  YES
                </label>
                <label style={{ fontWeight: "bold" }}>
                  <input
                    type="radio"
                    value="C"
                    checked={YesNo === "C"}
                    onChange={(e) => setYesNo(e.target.value)}
                  />
                  NO
                </label>
              </div>
            </div>
            <div className="form-column">
              <label>Reorder Level</label>
              <input
                type="text"
                value={ReorderLevel}
                onChange={(e) => setReorderLevel(allowNumbers(e.target.value))}
                style={inputStyle(errors.Category)}
              />
            </div>
            <div className="form-column">
              <label>HSN Code</label>
              <input
                type="text"
                value={HSNCode}
                onChange={(e) => setHSNCode(allowNumbers(e.target.value))}
                style={inputStyle(errors.Category)}
              />
            </div>
            <div className="form-column">
              <label>NDP</label>
              <input
                type="text"
                value={NDP}
                onChange={(e) => setNDP(allowNumbers(e.target.value))}
                style={inputStyle(errors.Category)}
              />
            </div>
            <div className="form-column">
              <label>MRP</label>
              <input
                type="text"
                value={MRP}
                onChange={(e) => setMRP(allowNumbers(e.target.value))}
                style={inputStyle(errors.Category)}
              />
            </div>
            <div className="form-column">
              <label>Qty Used</label>
              <input
                type="text"
                value={QtyUsed}
                onChange={(e) => setQtyUsed(allowNumbers(e.target.value))}
                style={inputStyle(errors.Category)}
              />
            </div>
            <div className="form-item-imd">
              <label>GST%</label>
              <Select
                options={gstOptions}
                value={
                  gstOptions.find((o) => o.value === GSTPercentage) || null
                }
                onChange={(selected) => setGSTPercentage(selected?.value || "")}
                styles={customStyles}
                placeholder="Select GST %"
                isSearchable
              />
            </div>

            <div className="form-column">
              <label>Category</label>
              <Select
                options={categoryOptions}
                value={
                  categoryOptions.find((o) => o.value === Category) || null
                }
                onChange={(selected) => setCategory(selected?.value || "")}
                styles={customStyles}
                placeholder="Select Category"
                isSearchable
              />
            </div>
            <div className="form-column">
              <label>Model Name</label>
              <Select
                options={modelOptions}
                value={modelOptions.find((o) => o.value === Model) || null}
                onChange={(selected) => setModel(selected?.value || "")}
                styles={customStyles}
                placeholder="Select Model"
                isSearchable
              />
            </div>
          </div>
          {/* Checkbox Grid */}
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="grid-scroll-wrapper">
              <div
                className="responsive-grid"
                style={{
                  marginTop: "10px",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  overflow: "hidden",
                  backgroundColor: "#fff",
                }}
              >
                {/* Header Row */}
                <div
                  style={{
                    fontWeight: "bold",
                    padding: "10px",
                    background: "#ff353561",
                    borderRight: "1px solid #ccc",
                    textAlign: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />{" "}
                  Select All
                </div>

                <div
                  style={{
                    fontWeight: "bold",
                    padding: "10px",
                    background: "#ff353561",
                    borderRight: "1px solid #ccc",
                  }}
                >
                  Model
                </div>

                <div
                  style={{
                    fontWeight: "bold",
                    padding: "10px",
                    background: "#ff353561",
                    borderRight: "1px solid #ccc",
                  }}
                >
                  Variant
                </div>

                <div
                  style={{
                    fontWeight: "bold",
                    padding: "10px",
                    background: "#ff353561",
                  }}
                >
                  QtyUsed
                </div>

                {/* Data Rows */}
                {GridModelList.map((m, i) => (
                  <React.Fragment key={m.value}>
                    {/* Checkbox */}
                    <div
                      style={{
                        padding: "10px",
                        textAlign: "center",
                        borderTop: "1px solid #ccc",
                        borderRight: "1px solid #ccc",
                        background: i % 2 === 0 ? "#fafafa" : "#fff",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={!!selectedRows[m.value]}
                        onChange={() => handleRowSelect(m.value)}
                      />
                    </div>

                    {/* Model */}
                    <div
                      style={{
                        padding: "10px",
                        borderTop: "1px solid #ccc",
                        borderRight: "1px solid #ccc",
                        background: i % 2 === 0 ? "#fafafa" : "#fff",
                      }}
                    >
                      {m.model}
                    </div>

                    {/* Variant */}
                    <div
                      style={{
                        padding: "10px",
                        borderTop: "1px solid #ccc",
                        borderRight: "1px solid #ccc",
                        background: i % 2 === 0 ? "#fafafa" : "#fff",
                      }}
                    >
                      {m.variant}
                    </div>

                    {/* QtyUsed */}
                    <div
                      style={{
                        padding: "10px",
                        borderTop: "1px solid #ccc",
                        background: i % 2 === 0 ? "#fafafa" : "#fff",
                        textAlign: "center",
                      }}
                    >
                      <input
                        type="text"
                        value={m.qtyUsed || ""}
                        onChange={(e) => {
                          const updated = [...GridModelList];
                          updated[i].qtyUsed = e.target.value;
                          setGridModelList(updated);
                        }}
                        style={{
                          width: "70px",
                          padding: "5px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                          textAlign: "center",
                        }}
                      />
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div style={buttonContainerStyle}>
            {!isEditMode && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}
            {isEditMode && (
              <button style={buttonStyle("#2e20abff")} onClick={handleUpdate}>
                Update
              </button>
            )}

            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      <style>
        {`
.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 10px;
}

.container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

.header {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 15px;
  background: linear-gradient(90deg, #8B1E3F, #8B1E3F);
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ================= FORM ================= */

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 20px;
  margin-bottom: 15px;
}

.form-column {
  display: flex;
  flex-direction: column;
}

/* ================= GRID ================= */

.grid-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
  display: block;
  scroll-behavior: smooth;
}

/* Flexible responsive grid */
.responsive-grid {
  display: grid;
  grid-template-columns: 90px 1fr 2fr 90px;
  width: max-content;
  min-width: 100%;
  background: #fff;
}

/* Tablet */
@media (max-width: 1024px) {
  .responsive-grid {
    grid-template-columns: 80px 180px 260px 100px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .responsive-grid {
    grid-template-columns: 70px 140px 220px 80px;
  }
}

/* ================= BUTTONS ================= */

.button-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 20px;
}

.button-container button {
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
}

.button-container button:active {
  transform: scale(0.97);
  opacity: 0.9;
}

/* ================= SMALL SCREEN FORM ================= */

@media (max-width: 480px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}
`}
      </style>
    </Layout>
  );
};

export default AccessoriesMasterDetailsDesign;
